module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui small modal",
    attrs: {
      "id": "cancelModal"
    }
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("\n    Cancel Booking\n  ")]), _vm._v(" "), (!_vm.cancelled) ? _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("To cancel a booking, please provide a reservation identifier - code, email or telephone number.")]), _vm._v(" "), _c('div', {
    staticClass: "ui huge fluid action input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Enter code, telephone or email"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ui primary button",
    on: {
      "click": _vm.searchReservation
    }
  }, [_vm._v("Search Booking")])]), _vm._v(" "), (_vm.searched) ? _c('div', [_c('div', {
    staticClass: "ui divider"
  }), _vm._v(" "), (!_vm.reservations) ? _c('div', {
    staticClass: "ui negative message"
  }, [_c('p', [_vm._v("No booking was found under the provided code\n        ")])]) : _c('div', {
    staticClass: "ui segments"
  }, [_c('div', {
    staticClass: "ui segment"
  }, [_c('h4', [_vm._v("Reservation for " + _vm._s(_vm.reservations[0].contact.firstName) + " " + _vm._s(_vm.reservations[0].contact.lastName))])]), _vm._v(" "), _c('div', {
    staticClass: "ui secondary segment"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "ui negative cancel-booking icon button"
  }, [_c('i', {
    staticClass: "trash icon"
  }), _vm._v(" Cancel This Booking")]), _vm._v(" "), _c('div', {
    staticClass: "ui special popup"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("Are you sure?")]), _vm._v(" "), _c('p', [_vm._v("This action is irreversible!")]), _vm._v(" "), _c('div', {
    staticClass: "ui icon primary button",
    on: {
      "click": _vm.cancelReservation
    }
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v(" Yes, cancel")])])]), _vm._v(" "), _c('table', {
    staticClass: "ui very basic table"
  }, [_c('tbody', _vm._l((_vm.bookings), function(booking) {
    return _c('tr', [_c('td', [_vm._v("\n                " + _vm._s(booking.boat.name) + "\n              ")]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(booking.hour) + " h\n              ")]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(_vm.moment(booking.date).format('ll')) + "\n              ")]), _vm._v(" "), _c('td', {
      staticClass: "right aligned"
    }, [_vm._v("\n                €" + _vm._s(_vm.numeral(booking.cost).format('0,0.00')) + "\n              ")])])
  })), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('strong', [_vm._v("Total")])]), _vm._v(" "), _c('td', {
    staticClass: "right aligned"
  }, [_c('strong', [_vm._v("€" + _vm._s(_vm.toPay))])])])])], 1)])])]) : _vm._e()]) : _c('div', {
    staticClass: "content"
  }, [(!_vm.reservation) ? _c('div', {
    staticClass: "ui info message"
  }, [_c('p', [_vm._v("Your booking was cancelled!\n      ")])]) : _vm._e()]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui icon cancel button"
  }, [_c('i', {
    staticClass: "delete icon"
  }), _vm._v(" Close\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05f675e1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/booking/CancelBooking.vue
// module id = 730
// module chunks = 1